<template>
  <div class="container center-block p-5">
    <div class="alert alert-danger" v-if="message!==''">
      {{message}}
    </div>
    <div class="card">
      <div class="card-header">
        <h5>Авторизация</h5>
      </div>
      <div class="card-body">
        <div class="form-group">
          <div class="row">
            <div class="col">
              <label>Email</label>
            </div>
            <div class="col">
              <input type="email" v-model="email" class="form-control">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col">
              <label>Пароль</label>
            </div>
            <div class="col">
              <input type="password" v-model="password" class="form-control">
            </div>
          </div>
        </div>
        <a @click ="Login"  class="btn btn-primary"  >Войти</a>
      </div>
    </div>



  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "Login",

  data: function (){
    return{
      email:'',
      password:'',
      status:'',
      message:'',
    }
  },
  methods:{
    Login(){
      let data = {
        email: this.email,
        password: this.password,
      }
      axios.post('/auth/login',data).then((response) => {
        this.status = response.status;
        this.$store.dispatch('saveToken', {
          token: response.data.access_token,
          remember: response.data.expires_in*1000 + (new Date()).getTime(),
        })
        this.message = '';
        this.$store.dispatch('fetchUser');
        this.$router.replace('/');
      }).catch(()=>{
        this.message = 'Неверный логин или пароль';
      });

    }
  }
}
</script>

<style scoped>

</style>